import { render } from "./Gestionale.vue?vue&type=template&id=73077a93&scoped=true"
import script from "./Gestionale.vue?vue&type=script&lang=js"
export * from "./Gestionale.vue?vue&type=script&lang=js"

import "./Gestionale.vue?vue&type=style&index=0&id=73077a93&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73077a93"]])

export default __exports__